import React from "react";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { BreadcrumbComponentItemTypes, BreadcrumbComponentProps } from "../../../config/InterfacesAndTypes";
import { RightOutlined } from "@ant-design/icons";
import SVGIcon from '../../../utils/SVGIcon'
/**
 * Renders a breadcrumb component for dashboard pages.
 *
 * @param {BreadcrumbComponentProps} props - The props object containing the items to be rendered.
 * @param {BreadcrumbComponentItemTypes[]} props.items - An array of items to be rendered as breadcrumbs.
 * @return {JSX.Element} The breadcrumb component.
 */
const BreadcrumbComponent: React.FC<BreadcrumbComponentProps> = ({ items }) => {
    return (
        <Breadcrumb items={items?.map((item: BreadcrumbComponentItemTypes, index: number) => {
            return {
                title: item.name,
                href: item.link
            }
            // <Breadcrumb.Item key={index}>
            //     {item.link ? <Link to={item.link}>{}</Link> : item.name}
            // </Breadcrumb.Item>
        })} className="ph-gutter" separator={<SVGIcon icon="BreadcrumbArrowIcon" />}/>
    );
};

export default BreadcrumbComponent;